import { atom } from "recoil"

export const globalLoadingVisibleAtom = atom({
    key: "globalLoadingVisibleAtom",
    default: false
})
